module.exports = __webpack_public_path__ + "img/PL09154.eff1cd88.png";